<template>
  <div class="img-wrap text-center audio-custom position-rel" :class="{'full-box': hiddenControls}">
    <div class="audio-custom__head aspect-ratio aspect-ratio--4-1-1 text-center" :class="{'full-box': hiddenControls}">
      <div class="audio-custom__head__wrap">
        <img :src="poster" alt="Media">
      </div>
    </div>
    <div class="audio-custom__body">
      <audio
        id="audio__file"
        :src="pathView"
        autoplay
        controls
        @timeupdate="handleTimeUpdate"
        controlsList="nodownload"
      />
      <div v-if="!hiddenControls" class="audio-custom__player">
        <div class="audio-custom__progress">
          <input type="range" class="audio-custom__ranger-time" title="duration" min="0" :max="duration" step="1" @change="changeCurrentTime">
          <div class="progress border-rd-0">
            <div class="progress__active primary-bg-color border-rd-0" :style="{width: `${progressBar}%`}"></div>
          </div>
        </div>
        <div v-if="!hiddenControls" class="audio-custom__action text-left  color-light">
          <button type="button" class="audio-custom__prev-time" :class="{'disabled': player && !player.currentTime}" @click="prevTime(10)">
            <i class="icon-back-10s"></i>
          </button>
          <button class="audio-custom__play" title="play/pause" accesskey="P" @click='playPauseAudio()'>
            <i v-if="isPlay" class="icon-pause color-light"></i>
            <span v-else class="icon-next"><span class="path1"></span><span class="path2"></span></span>
          </button>
          <button type="button" class="audio-custom__next-time" :class="{'disabled': player && player.currentTime && player.currentTime === duration}" @click="nextTime(10)">
            <i class="icon-next-10s"></i>
          </button>
          <!-- <button class="audio-custom__replay" title='replay' accesskey="R" @click='replayAudio()'>Replay</button> -->
          <!-- <button class="audio-custom__stop" title='stop' accesskey="X" @click='stopAudio()'>Stop</button> -->
          <!-- <input type="range" id="volume-bar" title="volume" min="0" max="1" step="0.1" value="1" @change="changeVolumn"> -->
          <button class="audio-custom__volumn" title='mute' @click="muteVolume()">
            <i class="icon-mute" v-if="player && player.muted"></i>
            <i class="icon-unmute" v-else></i>
          </button>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PreviewAudioPoster',
    props: {
      poster: String,
      pathView: String,
      autoPlay: Boolean,
      hiddenControls: Boolean,
      handleVolume: String
    },
    data () {
      return {
        duration: 0,
        volumn: 1,
        progressBar: 0,
        player: null,
        isPlay: false
      }
    },
    computed: {
      // player () {
      //   return document.getElementById('audio__file')
      // },
      playButton () {
        return document.getElementById('play')
      },
      playbackIcons () {
        return document.querySelectorAll('.playback-icons use')
      },
      progressBarTime () {
        // return this.$refs.progressbar
        return document.getElementById('progress-bar')
      },
      seek () {
        // return this.$refs.seek
        return document.getElementById('seek')
      },
      seekTooltip () {
        // return this.$refs.seek_tooltip
        return document.getElementById('seek-tooltip')
      },
      volume () {
        // return this.$refs.volume
        return document.getElementById('volume')
      },
    },
    watch: {
      handleVolume (newVal) {
        this.updateVolume(newVal)
      }
    },
    created () {
      this.isPlay = this.autoPlay
    },
    mounted () {
      this.player = document.getElementById('audio__file')
      this.getDurationAudio()
      this.handleEvts()
      this.playPauseAudio()
    },
    beforeDestroy () {
      this.playButton && this.playButton.removeEventListener('click', this.playPauseAudio)
      this.seek && this.seek.removeEventListener('mousemove', this.updateSeekTooltip)
      this.seek && this.seek.removeEventListener('input', this.skipAhead)
      this.volume && this.volume.removeEventListener('input', this.updateVolume)
    },
    methods: {

      handleEvts () {
        this.playButton && this.playButton.addEventListener('click', this.playPauseAudio)
        this.seek && this.seek.addEventListener('mousemove', this.updateSeekTooltip)
        this.seek && this.seek.addEventListener('input', this.skipAhead)
        this.volume && this.volume.addEventListener('input', this.updateVolume)
        this.player.addEventListener('loadedmetadata', this.initializeVideo)
        this.player.addEventListener('play', this.updatePlayButton)
        this.player.addEventListener('pause', this.updatePlayButton)
        this.player.addEventListener('timeupdate', this.updateProgress)
      },

      getDurationAudio () {
        setTimeout(() => {
          if (this.player) {
            this.duration = this.player.duration
          }
        }, 500)
      },

      handleTimeUpdate () {
        this.progressBar = Math.floor((100 / this.player.duration) * this.player.currentTime);
        if (this.player.ended) {
          this.isPlay = false
          this.$emit('ended', true)
        }
      },

      replayAudio () {
        this.resetPlayer();
        this.player.play();
      },

      playPauseAudio () {
        if (this.player.paused || this.player.ended) {
          this.player.play()
          this.isPlay = true
        } else {
          this.player.pause()
          this.isPlay = false
        }
      },

      updatePlayButton () {
        if (!this.playbackIcons || !this.playButton) {
          return
        }
        this.playbackIcons.forEach((icon) => icon.classList.toggle('hidden'))

        if (this.player.paused) {
          this.playButton.setAttribute('data-title', 'Pause (k)')
          this.$emit('audioPlay', 'pause')
        } else {
          this.playButton.setAttribute('data-title', 'Play (k)')
          this.$emit('audioPlay', 'play')
        }
      },

      stopAudio () {
        this.player.pause();
        if (this.player.currentTime) this.player.currentTime = 0;
      },

      muteVolume () {
        this.player.muted = this.player.muted ? false : true;
      },

      resetPlayer() {
        this.progressBar = 0;
        this.player.currentTime = 0;
      },

      changeVolumn (evt) {
        this.volume = parseInt(evt.target.value)
      },

      changeCurrentTime (evt) {
        this.player.currentTime = parseInt(evt.target.value)

        if (this.player.ended) {
          this.playButton.setAttribute('data-title', 'Pause (k)')
          this.$emit('audioPlay', 'pause')
        }
      },

      prevTime (time) {
        let currentTime = this.player.currentTime
        if (currentTime < time && currentTime > 0) {
          this.player.currentTime = 0
        } else if (currentTime > time) {
          this.player.currentTime -= time
        }
      },

      nextTime (time) {
        let currentTime = this.player.currentTime
        // console.log('Next time', time, currentTime);
        if (currentTime > (this.duration - time) && currentTime < this.duration) {
          this.player.currentTime = this.duration
        } else if (currentTime < (this.duration - time)) {
          this.player.currentTime += time
        }
      },

      formatTime (timeInSeconds) {
        const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8)

        return {
          minutes: result.substr(3, 2),
          seconds: result.substr(6, 2)
        }
      },

      skipAhead (event) {
        const skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value
        this.player.currentTime = skipTo
        this.progressBarTime.value = skipTo
        this.seek.value = skipTo
      },

      initializeVideo () {
        const audioDuration = Math.round(this.player.duration)
        this.seek.setAttribute('max', audioDuration)
        this.progressBarTime.setAttribute('max', audioDuration)
        // const time = this.formatTime(audioDuration)
        // this.duration.innerText = `${time.minutes}:${time.seconds}`
        // this.duration.setAttribute('datetime', `${time.minutes}m ${time.seconds}s`)
      },

      updateProgress () {
        this.seek.value = Math.ceil(this.player.currentTime)
        this.progressBarTime.value = Math.ceil(this.player.currentTime)
        // this.progressBar.value = Math.floor(this.player.currentTime)
      },

      // updateSeekTooltip uses the position of the mouse on the progress bar to
      // roughly work out what point in the video the user will skip to if
      // the progress bar is clicked at that point
      updateSeekTooltip (event) {
        const skipTo = Math.round(
          (event.offsetX / event.target.clientWidth) *
            parseInt(event.target.getAttribute('max'), 10)
        )
        this.seek.setAttribute('data-seek', skipTo)
        const t = this.formatTime(skipTo)
        this.seekTooltip.textContent = `${t.minutes}:${t.seconds}`
        const rect = this.player.getBoundingClientRect()
        this.seekTooltip.style.left = `${event.pageX - rect.left}px`
      },

      // updateVolume updates the video's volume
      // and disables the muted state if active
      // args val for parent component handle
      updateVolume (val = null) {
        if (this.player.muted) {
          this.player.muted = false
        }
        if (val) {
          this.player.volume = val.target ? val.target.value : val
          this.volume.value = val.target ? val.target.value : val
        } else {
          this.player.volume = this.volume.value
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .audio-custom {
    audio {
      @extend .display-none;
    }

    &__body {
      position: absolute;
      bottom: 5px;
      left: 0;
      right: 0;
      background: rgba(0,0,0,.3);
      padding: 0 10px;
    }

    &__progress {
      @extend .position-rel;

      * {
        @extend .full-width;
        padding: 0!important;
      }

      input {
        position: absolute;
        top: 0;
        left: 0;
        @extend .full-box;
        opacity: 0;
      }

      .progress {
        height: 5px;
        background: rgba(0,0,0,.1);

        &__active {
          height: 5px;
        }
      }
    }

    &__action {
      padding: 3px 0;

      button {
        @extend .border-0;
        @extend .bg-transparent;
        @extend .color-light;
        width: 30px;
        height: 30px;
        overflow: hidden;
        @extend .text-center;
        @extend .p-0;

        &:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
  }
</style>